// services/icd.js
import api from './api';

export const icdService = {
  searchIcdCodes: async (query, limit = 20) => {
    try {
      const response = await api.get(`/icd/search?q=${encodeURIComponent(query)}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error searching ICD codes:', error);
      return [];
    }
  },

  getCommonIcdCodes: async () => {
    try {
      const response = await api.get('/icd/common');
      return response.data;
    } catch (error) {
      console.error('Error fetching common ICD codes:', error);
      return [];
    }
  },

  getIcdCodesByChapter: async (chapter) => {
    try {
      const response = await api.get(`/icd/by-chapter/${encodeURIComponent(chapter)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ICD codes by chapter:', error);
      return [];
    }
  }
};
